


























import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class SecretPasswordBody extends Vue {
  @Prop() readonly data!: object;

  @Prop() readonly resetSecretPassword!: Function;

  @Prop() readonly report!: Function;
}
